// extracted by mini-css-extract-plugin
export default {"icon":"icon--1vHV5","icon--big":"icon--big--28P1k","icon--bigger":"icon--bigger--ooKD5","icon--huge":"icon--huge--3PN2b"};
    if(module.hot) {
      // 1747648138787
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  